<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <div class="section leaderboard-section new-design">
          <div class="section-content">
            <filter-header 
              :team-individual="leaderboardTeamIndividual"
              :scope="leaderboardScope"
              :aggr-method="leaderboardAgrgationMethod"
              @onTeamIndividualChange="onTeamIndividualChange"
              @onScopeChange="onScopeChange"
              @onAggrMethodChange="onAggrMethodChange"
              :teams="leaderboardTeams"
              :leaderboard-data="leaderboardData"
              :time-frame="leaderboardTimeFrame"
              @onTimeFrameChange="onTimeFrameChange"
              :selected-team="selectedTeamLeaderboard"
              :account="account" />

            <leaderboard-table 
              v-if="leaderboardData && leaderboardData"
              :leaderboard-data="leaderboardData"
              :scope="leaderboardScope"
              :time-frame="leaderboardTimeFrame"
              :team-individual="leaderboardTeamIndividual"
              :no-data="updateNoData"  />

              <div class="text-center" v-if="updateNoData">{{$t('LEADERBOARD.noTeam')}}</div>
              <div v-if="leaderboardTeamIndividual === 'individual'" class="leaderboard-note"> {{$t('LEADERBOARD.note')}} </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LeaderboardTable from '@/components/leaderboard/LeaderboardTable';
import FilterHeader from '@/components/leaderboard/FilterHeader';
import { 
  CHANGE_LEADERBOARD_SCOPE, 
  CHANGE_LEADERBOARD_AGREGATION_METHOD, 
  FETCH_LEADERBOARD_DATA, 
  FETCH_LEADERBOARD_TEAMS, 
  CHANGE_LEADERBOARD_TIME_FRAME,
  DESTROY_LEADERBOARD_DATA,
  CHANGE_LEADERBOARD_TEAM_INDIVIDUAL,
  FETCH_PLAYER_LEADERBOARD_DATA
} from '@/store/action.types';
import {
  mapActions,
  mapGetters
} from 'vuex';

export default {
  name: 'Leaderboard',
  components: {
    LeaderboardTable,
    FilterHeader
  },
  
  computed: {
    ...mapGetters([
      'leaderboardPreviewMode',
      'leaderboardFilter',
      'leaderboardData',
      'leaderboardScope',
      'leaderboardAgrgationMethod',
      'leaderboardTeams',
      'leaderboardTimeFrame',
      'updateNoData',
      'selectedTeamLeaderboard',
      'leaderboardTeamIndividual',
      'account'
    ])
  },
  mounted() {
      this.fetchLeaderboardTeams();
    // this.fetchLeaderboardData();   
  },
  methods: {
    ...mapActions({
      changeTeamIndividual: CHANGE_LEADERBOARD_TEAM_INDIVIDUAL,
      changeScope: CHANGE_LEADERBOARD_SCOPE,
      changeAgrMethod: CHANGE_LEADERBOARD_AGREGATION_METHOD,
      fetchLeaderboardData: FETCH_LEADERBOARD_DATA,
      fetchLeaderboardTeams : FETCH_LEADERBOARD_TEAMS,
      changeTimeFrame : CHANGE_LEADERBOARD_TIME_FRAME,
      destroyLeaderboardData : DESTROY_LEADERBOARD_DATA,
      fetchPlayerLeaderboardData: FETCH_PLAYER_LEADERBOARD_DATA
    }),
    onTeamIndividualChange (teamIndividual, playerId) {
      this.changeTeamIndividual({teamIndividual, playerId});
    },
    onScopeChange (scope, playerId) {
      this.changeScope({scope, playerId});
    },
    onAggrMethodChange (aggrMethod, playerId) {
      this.changeAgrMethod({aggrMethod, playerId});
    },
    onTimeFrameChange (timeFrame, playerId) {
      this.changeTimeFrame({timeFrame, playerId});
    }
  },
  watch : {
    account (newAccount) {
      if (this.leaderboardTeamIndividual === 'individual') {
        this.fetchPlayerLeaderboardData(newAccount.playerId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .leaderboard-section {
    max-width: 1200px;
    .leaderboard-note {
      margin-top: 30px;
      color: #636363;
      font-style: italic;
      text-align: center;
    }
  }
</style>